import { render, staticRenderFns } from "./ProjectValuationReportResponsiveContainer.vue?vue&type=template&id=ddf70166&scoped=true&"
import script from "./ProjectValuationReportResponsiveContainer.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationReportResponsiveContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationReportResponsiveContainer.vue?vue&type=style&index=0&id=ddf70166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf70166",
  null
  
)

export default component.exports